export const environment = {
  production: false,
  defaultBrand: 'starkey',
  engageCloudFunctionsUrl: 'https://us-central1-starkey-engage-develop.cloudfunctions.net',
  patientAuthenticationServiceUrl: 'https://auth-develop.starkeytelehear.com',
  thriveCloudFunctionsUrl: 'https://us-central1-sandbox1-34905.cloudfunctions.net',
  caregiverAuthenticationServiceUrl: 'https://api-caregiverauthservice.develop.thrivecareanywhere.com',
  //cloudCoreApiUrl: 'https://core-integration.telehearportal.com',
  cloudCoreApiUrl: 'https://core-develop.telehearportal.com',
  patientDataServiceUrl: 'https://develop.pds.starkeytelehear.com',
  appleServiceId: 'com.starkey.genesis.serviceid',
  recaptchaSiteKey: '6Lcec9MtAAAAACtZ29C7SazudjOagCKU7mciSpz4',
  appName: 'phonesupport-develop'
};
